module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.redefine.js
// module id = 177
// module chunks = 174 178 179 182 193 194 195